import React, { useState, useEffect } from "react";
import { Layout, Menu } from "antd";
import { MenuOutlined, CloseOutlined, UserOutlined } from "@ant-design/icons";
import {
  HomeOutlined,
  TeamOutlined,
  SolutionOutlined,
  NotificationOutlined,
  ToolOutlined,
  FolderOutlined
} from "@ant-design/icons";
import { InboxOutlined } from "@ant-design/icons";
import { Avatar, Button } from "antd";
import { Tooltip } from "@mui/material";
import { PoweroffOutlined, PlusOutlined,StarOutlined } from "@ant-design/icons";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import InventoryIcon from "@mui/icons-material/Inventory";
import { Campaign as CampaignIcon } from "@mui/icons-material";
import { useNavigate, Outlet } from "react-router-dom";
import "./Dashboard.css";
import AdvertisementModal from "../Pages/AddAdvertisement";
import { Dropdown } from "antd";
import AssessmentIcon from "@mui/icons-material/Assessment";

const { Header, Sider, Content } = Layout;




const advertisementMenuItems = [
  {
    key: "/dashboard/advertisement-list",
    label: "Advertisement",
    icon: <CampaignIcon style={{ fontSize: 16 }} />,
  },
  {
    key: "/dashboard/extraadvertisement-list",
    label: "Extra Advertisement",
    icon: <NotificationOutlined />,
  },
];


const DashboardPage = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [folderOpen, setFolderOpen] = useState(false);


  const [loading, setLoading] = useState(false); 

  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    sessionStorage.clear();
    window.location.href = "/";
  };

  const handleMenuClick = (path) => {
     setFolderOpen(false);
  navigate(path);
     if (isMobile || window.innerWidth <= 1024) {
    setSidebarOpen(false);
  }
};


  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100vh",
        display: "flex",
        backgroundColor: "#eff6fe",
        border: "7px solid #184459ff",
        borderRadius: "12px",
        boxSizing: "border-box",
        overflow: "hidden",
        zIndex: 1,
      }}
    >
   
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <img
            src="/images/loader-symbol.gif"
            alt="Loading"
            style={{ width: 100, height: 100 }}
          />
        </div>
      )}

      <Layout   style={{
    marginLeft: isMobile ? 0 : folderOpen ? 200 : 0,
    transition: "all 0.3s",
  }}>
        {/* SIDEBAR */}
        <Sider
          width={70}
          collapsedWidth={0}
          collapsible
          trigger={null}
          collapsed={isMobile ? !sidebarOpen : false}
          style={{
            background: "#184459ff",
            color: "black",
            transition: "all 0.3s",
            boxShadow: "5px 0 15px rgba(0,0,0,0.5)",
            borderRight: "1px solid #184459ff",
            zIndex: 20,
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
          }}
        >
          {isMobile && (
            <div
              style={{
                width: "100%",
                height: "50px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderBottom: "1px solid #eee",
              }}
            >
              <CloseOutlined
                style={{ fontSize: "22px", cursor: "pointer", color: "white" }}
                onClick={() => setSidebarOpen(false)}
              />
            </div>
          )}

          {!isMobile && (
            <div className="logo-container">
              <img
                src={`${process.env.PUBLIC_URL}/images/NewLogo.png`}
                alt="Logo"
                style={{
                  width: "70px",
                  height: "60px",
                  margin: "5px auto 10px",
                  display: "block",
                }}
              />
            </div>
          )}

          <Menu
            mode="inline"
            defaultSelectedKeys={["1"]}
            style={{
              background: "transparent",
              border: "none",
              textAlign: "center",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "5px",
              marginTop: isMobile ? "20px" : "0px",
            }}
            items={[
              {
                key: "1",
                icon: (
                  <Tooltip title="Home" arrow>
                    <HomeOutlined
                      style={{ fontSize: 20, color: "white" }}
                      onClick={() => handleMenuClick("/dashboard/home")}
                    />
                  </Tooltip>
                ),
              },
                {
                key: "2",
                icon: (
                  <Tooltip title="customers" arrow>
                    <UserOutlined
                      style={{ fontSize: 20, color: "white" }}
                      onClick={() => handleMenuClick("/dashboard/customer-list")}
                    />
                  </Tooltip>
                ),
              },
              
              {
                key: "3",
                icon: (
                  <Tooltip title="Appointments" arrow>
                    <EventAvailableIcon
                      style={{ fontSize: 20, color: "white" }}
                      onClick={() =>
                        handleMenuClick("/dashboard/appointment-booking-list")
                      }
                    />
                  </Tooltip>
                ),
              },
              {
                key: "4",
                icon: (
                  <Tooltip title="Installations" arrow>
                    <SolutionOutlined
                      style={{ fontSize: 20, color: "white" }}
                      onClick={() =>
                        handleMenuClick("/dashboard/installation-list")
                      }
                    />
                  </Tooltip>
                ),
              },
              {
                key: "5",
                icon: (
                  <Tooltip title="Products" arrow>
                    <InventoryIcon
                      style={{ fontSize: 20, color: "white" }}
                      onClick={() => handleMenuClick("/dashboard/product-list")}
                    />
                  </Tooltip>
                ),
              },
               {
                key: "6",
                icon: (
                  <Tooltip title="technician" arrow>
                    <ToolOutlined
                      style={{ fontSize: 20, color: "white" }}
                      onClick={() => handleMenuClick("/dashboard/technician-list")}
                    />
                  </Tooltip>
                ),
              },
              {
                key: "7",
                icon: (
                  <Tooltip title="Offers" arrow>
                    <StarOutlined
                      style={{ fontSize: 20, color: "white" }}
                      onClick={() => handleMenuClick("/dashboard/offer-list")}
                    />
                  </Tooltip>
                ),
              },
           {
  key: "8",
  icon: (
    <Dropdown
      menu={{
        items: [
          {
            key: "/dashboard/advertisement-list",
            label: "Advertisement",
            icon: <CampaignIcon style={{ fontSize: 16 }} />,
          },
          {
            key: "/dashboard/extraadvertisement-list",
            label: "Extra Advertisement",
            icon: <NotificationOutlined />,
          },
        ],
        onClick: ({ key }) => handleMenuClick(key),
      }}
      placement="rightTop"
      trigger={isMobile ? ["click"] : ["hover"]}    
      
    >
     
        <CampaignIcon
          style={{
            fontSize: 20,
            color: "white",
            cursor: "pointer",
          }}
        />
     
    </Dropdown>
  ),
},
{
  key: "9",
  icon: (
    <Tooltip title="Report" arrow>
      <AssessmentIcon
        style={{ fontSize: 20, color: "white" }}
                      onClick={() => handleMenuClick("/dashboard/report")}
      />
    </Tooltip>
  ),
},
{
  key: "10",
  icon: (
    <Dropdown
      menu={{
        items: [
          {
            key: "/dashboard/packages",
            label: "Add Packages",
            
          },
          {
            key: "/dashboard/packagepurchses",
            label: "Package Purchases",
           
          },
        ],
        onClick: ({ key }) => handleMenuClick(key),
      }}
      placement="rightTop"
     trigger={isMobile ? ["click"] : ["hover"]} 
    >
      <InboxOutlined
        style={{
          fontSize: 20,
          color: "white",
          cursor: "pointer",
        }}
      />
    </Dropdown>
  ),
},
{
  key: "10",
  icon: (
    <Tooltip title="Folders" arrow>
      <FolderOutlined
        style={{ fontSize: 20, color: "white", cursor: "pointer" }}
       onClick={() => {
  setFolderOpen(true);
  if (isMobile) {
    setSidebarOpen(false);
  }
}}

      />
    </Tooltip>
  ),
},


              
              
               
            ]}
          />
        </Sider>
      
{folderOpen && (
  <Sider
    width={200}
    style={{
      background: "#fff",
      position: "fixed",
      left: isMobile ? 0 : 70,
      top: 0,
      height: "100vh",
      zIndex: 15,
      boxShadow: "8px 0 15px rgba(0,0,0,0.25)",
    }}
  >

    <div
      style={{
        height: 50,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0 12px",
        borderBottom: "1px solid #eee",
      }}
    >
      <span style={{ fontWeight: 600, color: "#184459ff" }}>
        Folders
      </span>

      <div
        style={{
          padding: 6,
          borderRadius: 6,
          cursor: "pointer",
        }}
        onMouseEnter={(e) =>
          (e.currentTarget.style.background = "#f5f5f5f5")
        }
        onMouseLeave={(e) =>
          (e.currentTarget.style.background = "transparent")
        }
        onClick={() => setFolderOpen(false)}
      >
        <CloseOutlined />
      </div>
    </div>

<div style={{ padding: 10 }}>
  {[
    { label: "Service List", path: "/dashboard/service-list" },
    { label: "CameraBrands List", path: "/dashboard/camerabrand-list" },
    { label: "Intercomm List", path: "/dashboard/intercomm-list" },
     { label: "CameraType List", path: "/dashboard/cameratype-list" },
      { label: "Wire List", path: "/dashboard/wiredmaster-list" },
       { label: "Request List", path: "/dashboard/request-list" },
        { label: "SiteType List", path: "/dashboard/sitetype-list" },
         { label: "TimeSlot List", path: "/dashboard/timeslot-list" },
          { label: "SurveyAim List", path: "/dashboard/requesttype-list" },
           { label: "OfferType List", path: "/dashboard/offertype-list" },
            { label: "Status List", path: "/dashboard/status-list" },
            { label: "Package Type List", path: "/dashboard/packagetype-list" },
             { label: "Package SubType List", path: "/dashboard/packagesubtype-list" },
              
  ].map((item) => (
    <div
      key={item.path} 
      onClick={() => handleMenuClick(item.path)} 
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "10px 12px",
        borderRadius: 8,
        cursor: "pointer",
        color: "#000",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.background = "#f5f5f5")}
      onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
    >
      {/* optional icon */}
      {item.icon && <span>{item.icon}</span>}
      <span style={{ fontSize: 14,fontWeight:500,marginTop:"5px" }}>{item.label}</span>
    </div>
  ))}
</div>

  </Sider>
)}



        {/* MAIN CONTENT */}
        <Layout style={{ marginLeft: isMobile ? 0 : 60, transition: "all 0.3s" }}>
          <Header
            style={{
              background: "#ffffff",
              padding: "0 20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: "50px",
              position: "sticky",
              top: 0,
              zIndex: 5,
              boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
            }}
          >
            {isMobile && (
              <Button
                type="text"
                icon={<MenuOutlined style={{ fontSize: 20 }} />}
                onClick={() => setSidebarOpen(true)}
              />
            )}

            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "auto",
                gap: "10px",
              }}
            >


              <Tooltip title="Logout">
                <Avatar
                  icon={<PoweroffOutlined />}
                  onClick={handleLogout}
                  style={{
                    backgroundColor: "#184459ff",
                    cursor: "pointer",
                  }}
                />
              </Tooltip>
            </div>
          </Header>

          <Content
            style={{
              maxHeight: "100vh",
              overflow: "hidden",
              background: "transparent",
            }}
          >
            <div
              style={{
                height: "100%",
                overflowY: "auto",
                paddingLeft: "15px",
                paddingRight: "10px",
                background: "#ffffff",
                borderRadius: "12px",
              }}
              className="scroll-wrapper"
            >
             <Outlet context={{ setLoading }} />

            </div>
          </Content>
        </Layout>
      </Layout>

      {modalVisible && (
        <AdvertisementModal onClose={() => setModalVisible(false)} />
      )}
    </div>
  );
};

export default DashboardPage;
